import { render } from "./DadosBoleto.vue?vue&type=template&id=0384b662"
import script from "./DadosBoleto.vue?vue&type=script&lang=js"
export * from "./DadosBoleto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__